import { Page } from '@/core/architecture'

import { ConsoleDigitalMembershipDefaultCardDesignEditTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleDigitalMembershipDefaultCardDesignEdit Page
 * 会員証デザインを変更する画面
 */
export const ConsoleDigitalMembershipDefaultCardDesignEdit: Page = () => {
  const { state, actions } = useViewModel()

  return (
    <ConsoleDigitalMembershipDefaultCardDesignEditTemplate
      state={state}
      {...actions}
    />
  )
}
